import { fromJS } from 'immutable';
import Cookie from 'js-cookie';
import { USER_LOAD, SET_TOKEN } from './actionTypes';
import { START, SUCCESS, ERROR } from '../../consts';
import api from '../../apiSingleton';

export function setToken (token) {
  return {
    type: SET_TOKEN,
    payload: token
  };
}

export function getUser ({ token = null } = {}) {
  return (dispatch, getState) => {
    const _token = token || getState().getIn(['user', 'token']) || Cookie.get('msessionid') || null;

    if (!_token) {
      return dispatch({
        type: USER_LOAD + ERROR,
        payload: {message: 'Token not exist'}
      });
    }

    dispatch({
      type: USER_LOAD + START,
      payload: _token
    });

    return api.user
      .profile(_token)
      .then(data =>
        dispatch({
          type: USER_LOAD + SUCCESS,
          payload: fromJS(data)
        })
      ).catch(error => dispatch({
        type: USER_LOAD + ERROR,
        payload: error
      }));
  };
}



// WEBPACK FOOTER //
// ./src/app/User/actions.js